import type { RouteObject } from "react-router";
import { MEETING_ROUTES } from "../constants/meeting-routes";

export const meetingRoutes: RouteObject = {
	children: [
		{
			path: MEETING_ROUTES.LIST,
			lazy: async () => {
				const { default: MeetingsPage } = await import("../pages/meetings-page");
				return { Component: MeetingsPage };
			},
		},
		{
			path: MEETING_ROUTES.CREATE,
			lazy: async () => {
				const { default: MeetingCreatePage } = await import("../pages/meeting-create-page");
				return { Component: MeetingCreatePage };
			},
		},
		{
			path: MEETING_ROUTES.PREVIEW,
			lazy: async () => {
				const { default: MeetingPreviewPage } = await import("../pages/meeting-preview-page");
				return { Component: MeetingPreviewPage };
			},
		},
		{
			path: MEETING_ROUTES.DETAIL,
			lazy: async () => {
				const { default: MeetingDetailPage } = await import("../pages/meeting-detail-page");
				return { Component: MeetingDetailPage };
			},
		},
		{
			path: MEETING_ROUTES.EDIT,
			lazy: async () => {
				const { default: MeetingEditPage } = await import("../pages/meeting-edit-page");
				return { Component: MeetingEditPage };
			},
		},
	],
};

export const meetingPublicRoutes: RouteObject = {
	path: MEETING_ROUTES.PUBLIC_DETAIL,
	lazy: async () => {
		const { default: PublicMeetingPage } = await import("../pages/public-meeting-page");
		return { Component: PublicMeetingPage };
	},
};
